import { Activity, ArrowRight, LoaderIcon, Route } from 'lucide-react';
import { metersToMiles } from '../lib/utils';
import { useWeeklyStats } from '../hooks/useProfile';
import { useNavigate } from '@tanstack/react-router';

const WeeklyMetrics = () => {
  const navigate = useNavigate();
  const { weeklyStats, isLoading } = useWeeklyStats();
  const totalMiles = metersToMiles(weeklyStats.totalDistance).toFixed(1);

  const metrics = [
    {
      label: 'Miles',
      value: totalMiles,
      unit: 'mi',
      icon: Route,
    },
    {
      label: 'Workouts',
      value: weeklyStats.workoutCount,
      unit: 'total',
      icon: Activity,
    },
  ];

  return (
    <section className="depth-panel w-full rounded-2xl p-5 text-left">
      <div className="mb-4 flex items-center justify-between gap-3">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-brand-cobalt">
            Weekly Progress
          </p>
          <h2 className="mt-1 text-xl font-black tracking-[-0.03em] text-brand-midnight">
            This week so far
          </h2>
        </div>
        <div className="flex items-center gap-3">
          {isLoading ? (
            <LoaderIcon className="h-5 w-5 animate-spin text-brand-cobalt" />
          ) : null}
          <button
            type="button"
            onClick={() => navigate({ to: '/workouts' })}
            className="inline-flex items-center gap-1 text-xs font-bold text-brand-cobalt hover:text-brand-midnight"
          >
            View activities
            <ArrowRight className="h-3.5 w-3.5" />
          </button>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3">
        {metrics.map((metric) => {
          const Icon = metric.icon;
          return (
            <div
              key={metric.label}
              className="depth-inset rounded-xl p-4 ring-1 ring-slate-100 dark:ring-slate-700"
            >
              <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-lg bg-brand-cobalt/10 ring-1 ring-inset ring-brand-cobalt/20 dark:bg-brand-cobalt/15 dark:ring-brand-cobalt/30">
                <Icon className="h-5 w-5 text-brand-cobalt" strokeWidth={2} />
              </div>
              <div className="flex items-baseline gap-1">
                <span className="text-3xl font-black tracking-[-0.05em] text-brand-midnight">
                  {isLoading ? '—' : metric.value}
                </span>
                <span className="text-sm font-bold text-gray-500">
                  {metric.unit}
                </span>
              </div>
              <p className="mt-1 text-sm font-medium text-gray-600">
                {metric.label}
              </p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default WeeklyMetrics;
